import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../localization';
import LabelIcon from './label-icon';
import useCountdown from '../hooks/use-countdown';

function DiscountBanner({ discount, endDate, termsLink }) {
  const [days, hours, minutes, seconds] = useCountdown(endDate);
  const daysString = days > 0 ? `${days}d ` : '';
  const minutesString = minutes < 10 ? `0${minutes}` : minutes.toString();
  const secondsString = seconds < 10 ? `0${seconds}` : seconds.toString();
  return (
    <div className="ws-paywall-discount-banner">
      <div className="ws-paywall-discount-banner__inner">
        <span className="ws-paywall-discount-banner__label">
          <LabelIcon />
          <span className="ws-paywall-discount-banner__label-text">-{discount}%</span>
        </span>
        <span>
          <strong>{t('Limited time offer! ')}</strong>
          {t('Get')}
          <span className="ws-paywall-discount-banner__marked-text"> {discount}% </span>
          {t('off your first purchase. Offer ends in')}
          <strong>{` ${daysString}${hours}:${minutesString}:${secondsString}`}</strong>
        </span>
        <a
          href={termsLink}
          target="_blank"
          rel="noreferrer noopener"
          className="ws-paywall-discount-banner__terms"
        >
          {t('Terms and conditions')}
        </a>
      </div>
    </div>
  );
}

DiscountBanner.propTypes = {
  discount: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  termsLink: PropTypes.string.isRequired,
};
export default DiscountBanner;
